import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const SUPPORTED_LOCALES = [
  'en',
  'zh-CN',
  'zh-TW',
  'id',
  'pt-BR',
  'ja',
  'ko',
  'vi',
  'th',
  'ms',
] as const;

export type LocaleCode = (typeof SUPPORTED_LOCALES)[number];

interface LanguageState {
  language: LocaleCode | null; // null = follow browser detector
  setLanguage: (l: LocaleCode | null) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: null,
      setLanguage: (l) => set({ language: l }),
    }),
    { name: 'bz-language' },
  ),
);
